import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LockSmall from 'assets/svgs/lockSmall.svg';
import Lock from 'assets/svgs/lock.svg';
import { ONLINE_REGS_STATUSES, ONLINE_REGS_STATUS_INITIALS } from 'shared/constants';
import './StudentStatus.scss';
import {
  ModalInfo, Dropdown, DropdownItem, AlertNotice, Textarea,
} from 'shared/components';
import LockBlue from 'assets/svgs/lockBlue.svg';
import UnlockBlue from 'assets/svgs/unlockBlue.svg';
import { useDispatch } from 'react-redux';
import * as onlineTestingActions from '../duck';
import OnlineTestingService from '../OnlineTestingService';

const StudentStatus = ({
  cellData,
  scrollPosition,
  className,
  smallIcon,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const icon = cellData.locked ? <UnlockBlue /> : <LockBlue />;
  const lockedText = cellData.locked ? 'unlock' : 'lock';
  const dispatch = useDispatch();

  const handleLockUnlock = async (lockedStatus) => {
    const data = [{
      regId: cellData.id,
      locked: lockedStatus,
    }];
    await OnlineTestingService.putLockedRegs(data);
    dispatch(onlineTestingActions.getOnlineIndividualReg(cellData.id));
  };
  const isDropdownAvailable = cellData.testStatus === ONLINE_REGS_STATUS_INITIALS.active
    || cellData.testStatus === ONLINE_REGS_STATUS_INITIALS.resumed
    || cellData.testStatus === ONLINE_REGS_STATUS_INITIALS.exited
    || cellData.testStatus === ONLINE_REGS_STATUS_INITIALS.ready;

  const toggleModal = () => {
    setError('');
    setIsModalOpen(!isModalOpen);
    setReason('');
  };

  const handleDropdownClick = async (status, reason) => {
    const data = [{
      regId: cellData.id,
      testStatus: status,
      proctorTerminate: reason ?? '',
    }];
    await OnlineTestingService.putStudentStatus(data);
    dispatch(onlineTestingActions.getOnlineIndividualReg(cellData.id));
  };

  const onChange = (e) => {
    const { value } = e.target;
    setError('');
    setReason(value);
  };

  const handleContinue = () => {
    if (!reason) {
      setError(t('errors.fieldRequired'));
      return;
    }
    handleDropdownClick(ONLINE_REGS_STATUS_INITIALS.markedComplete, reason);
    setIsModalOpen(false);
  };
  const lockIcon = cellData.locked ?
    (smallIcon ? <LockSmall /> : <Lock />) : undefined;

  return (
    <>
      <Dropdown
        icon={lockIcon}
        title={ONLINE_REGS_STATUSES[cellData.testStatus] || ONLINE_REGS_STATUSES.notReady}
        chevron={isDropdownAvailable
      ? <i className="fa fa-chevron-down" aria-hidden="true" /> : <div className="no-arrow"></div>}
        customClass={`status-dropdown-component ${className} ${ONLINE_REGS_STATUSES[cellData.testStatus] || ONLINE_REGS_STATUSES.notReady}`}
        isDropdownAvailable={isDropdownAvailable}
        scrollPosition={scrollPosition}
      >
        <div className="status-dropdown">
          {cellData.testStatus !== ONLINE_REGS_STATUS_INITIALS.ready && (
          <>
            {(cellData.testStatus === ONLINE_REGS_STATUS_INITIALS.exited || cellData.testStatus === ONLINE_REGS_STATUS_INITIALS.active)
          && (
          <DropdownItem
            handleClick={() => {
              handleDropdownClick(ONLINE_REGS_STATUS_INITIALS.resumed);
            }}
            text={t('onlineTesting.individualStatus.resume')}
          />
          )}
            <DropdownItem
              handleClick={toggleModal}
              text={t('onlineTesting.individualStatus.markComplete')}
            />
            <div className="separator" />
          </>
          )}
          <DropdownItem
            handleClick={() => { handleLockUnlock(!cellData.locked); }}
            icon={icon}
            text={t(`onlineTesting.lockUnlock.${lockedText}`)}
          />
        </div>
      </Dropdown>
      <ModalInfo
        className="modal-mark-complete"
        modalIsOpen={isModalOpen}
        closeModal={toggleModal}
        onSubmit={handleContinue}
        headerTitle={t('onlineTesting.individualStatus.reason')}
        saveLabel={t('onlineTesting.individualStatus.markComplete')}
        cancelLabel={t('common.labels.cancel')}
        showCancel
      >
        <div>
          <div className="student-name">{`${cellData.lastName}, ${cellData.firstName}`}</div>
          <AlertNotice message={t('onlineTesting.individualStatus.alert')} type="warning" />
          <Textarea
            label={t('onlineTesting.individualStatus.completeReason')}
            labelInfo={t('onlineTesting.individualStatus.markingReason')}
            name="completeReason"
            value={reason}
            onChange={onChange}
            maxLength={500}
            error={error}
          />
        </div>
      </ModalInfo>
    </>
  );
};
export default StudentStatus;

StudentStatus.propTypes = {
  className: PropTypes.string,
};

StudentStatus.defaultProps = {
  className: '',
};
